import ProjectSession from "../project-session"
import {EntityType} from "../../../gd/const/item"

// const debug = "projectSession_checkIfAvailableAsParentFor"
const debug = false

// determines if the project can serve as a parent for any entity type listed in parentFor
export default function projectSession_checkIfAvailableAsParentFor(project: ProjectSession, parentFor: EntityType[]) {

    debug && console.log(debug, 'process', parentFor)

    return _.some(parentFor, (entityType: EntityType) => {
        return project.acl.canCreateEntity(entityType)
    })
}